<script lang="ts">
  // Account → Follows tab. Single tab on the account page that exposes
  // both the user's Following list and their Followers list via an
  // inner sub-toggle. Reuses the shared FollowsList component — same
  // one the public profile uses.
  //
  // Sub-tab is component-local state; we don't mirror it to the URL
  // since the parent account page already owns ?tab=follows. Adding
  // a second query param for the sub-toggle would muddy that.

  import FollowsList from '../../components/FollowsList.svelte';
  import { user } from '../../lib/stores/auth';

  type SubTab = 'following' | 'followers';

  let active = $state<SubTab>('following');
</script>

{#if $user}
  <div class="follows-tab">
    <div class="follows-tab__pills" role="tablist" aria-label="Follow lists">
      <button
        type="button"
        role="tab"
        aria-selected={active === 'following'}
        class="follows-tab__pill"
        class:follows-tab__pill--active={active === 'following'}
        onclick={() => (active = 'following')}
      >
        Following
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'followers'}
        class="follows-tab__pill"
        class:follows-tab__pill--active={active === 'followers'}
        onclick={() => (active = 'followers')}
      >
        Followers
      </button>
    </div>

    <FollowsList username={$user.username} kind={active} />
  </div>
{/if}
